<div class="header_hero-bg"></div>

<div class="report-trade-container container-fluid">
  <div class="row report_body-content">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 report_header-information">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
          <div class="report_header-information__sub-header" id="report-title">
            RCR Volme Summary Report
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-container">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break__padding">
          <div class="line-break"></div>
        </div>
      </div>
    </div>

    <div
      class="col-12 col-sm-12 col-md-12 col-lg-12 issuance-trade-form line-break__padding reports-alignment"
    >
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
          <input
            [(ngModel)]="year"
            type="number"
            placeholder="YYYY"
            min="2017"
            [max]="year"
            size="10"
          />
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
          <button
            class="button fm-primary-button run-report"
            id="run-report"
            (click)="runReport(year)"
          >
            RUN
          </button>
          <button
            class="button fm-primary-button view-report"
            id="view-report"
            (click)="viewReport()"
          >
            DOWNLOAD REPORT (EXCEL)
          </button>
        </div>
      </div>
      <!--   <div class="col-12 col-sm-12 col-md-12 col-lg-12">

      </div>-->
      <!--      <h3 class="issuance-data-tab-title" id="issuance-report-sub-header">RCR Volume Report</h3>-->
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break__padding view-report-seperator">
          <div class="line-break-view-report"></div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
          <div class="response-message" *ngIf="responseMessageFlag">
            {{ responseMessage }}
          </div>
          <div class="fm-cdx-table" *ngIf="!responseMessageFlag">
            <table class="fm-cdx-table__static">
              <thead>
                <tr class="th_row">
                  <th class="th_column th_icon">Month</th>
                  <th class="th_column th_icon">Deal Type</th>
                  <th class="th_column th_icon">Count</th>
                  <th class="th_column th_icon">Current Face Amount</th>
                  <th class="th_column th_icon">Exchange Fee Dollars</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="td_row commit-mega-table-header"
                  *ngFor="let rcr of rcrVolumeData; trackBy: trackByIdentity"
                >
                  <td class="td_cell td_icon">
                    <span class="collateral-big">{{ rcr?.monthString }}</span>
                  </td>
                  <td class="td_cell td_icon">
                    <span class="collateral-big">{{ rcr?.displayDealType }}</span>
                  </td>
                  <td class="td_cell td_icon">
                    <span class="collateral-big">{{ rcr?.count }}</span>
                  </td>
                  <td class="td_cell">
                    <span class="collateral-big">{{ rcr?.currentFaceAmountStr }}</span>
                  </td>
                  <td class="td_cell">
                    <span class="collateral-big">{{ rcr?.exchangeFeeDollarsStr }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- <div class="col-12 col-sm-12 col-md-6 col-lg-6">
        <p class="report-updated-text" id="report-updated">Report updated every business day at 8am & 12pm EST</p>
      </div>-->
    </div>
  </div>
</div>
